import { handleActions } from 'redux-actions';
import * as actions from '../../actions/emision/asegurados.actions';

const initialState = {
  loadingCatalogo: false,
  loadingEditarBeneficiarios: false,
  errorCatalogo: null,
  isShowFormAdd: false,
  parentescoFormAdd: null,
  catalogoForm: null,
};

const EmisionAseguradosReducer = handleActions(
  {
    [actions.setLoadingCatalogoAction]: (state, { payload }) => ({
      ...state,
      loadingCatalogo: payload,
    }),
    [actions.setCatalogoAction]: (state, { payload }) => ({ ...state, ...payload }),
    [actions.setShowFormAgregarAction]: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
    [actions.setLoadingEditarBeneficiariosAction]: (state, { payload }) => ({
      ...state,
      loadingEditarBeneficiarios: payload,
    }),
    [actions.resetStateAction]: () => ({ ...initialState }),
    // [actions.resetStateAction]: (state) => ({ ...state }),
  },
  initialState,
);

export default EmisionAseguradosReducer;
